"use strict";

var getDecimalAmount = require('./utils').getDecimalAmount;

function round1(val) {
  return Math.round(val * 10) / 10;
}

/* Return unit m3*/
exports.build = function(result, config) {

  var values = [];
  for (var i = 0; i < config.decimals.positions.length; i++) {
    values.push(result.meters[i].value);
  }

  // round individual numbers first
  for (var j = 1; j < config.decimals.positions.length; j++) {
    // check if previous precision is missing -> in that case, round value to 1 decimal
    if (config.decimals.positions[j - 1].precision * 10 == config.decimals.positions[j].precision
      && values[j - 1] > -1) { // all good, roung to integer
      values[j] -= (values[j - 1] / 10);
      values[j] = Math.round(values[j]);
      if (values[j] == 10) values[j] = 0;
      if (values[j] == -1) values[j] = 9;
    } else { // round to 1 decimal
      values[j] = Math.round(values[j] * 10) / 10;
    }
  }

  var res = 0;
  // check special case nbr1 where 2 pointers are missing -> result will be taken from only one pointer
  if (config.decimals.positions.length === 2
    && parseFloat(config.decimals.positions[0].precision) == 0.0001
    && parseFloat(config.decimals.positions[1].precision) == 0.1) {
    res = values[1] * config.decimals.positions[1].precision;
  } else if (config.decimals.positions.length === 3 // check special case nbr2 where 1 pointer missing -> result will be taken from only 2 pointers, desilitre data will be patched from noflow data
    && parseFloat(config.decimals.positions[0].precision) == 0.0001
    && parseFloat(config.decimals.positions[1].precision) == 0.01
    && parseFloat(config.decimals.positions[2].precision) == 0.1) {
    res = values[2] * config.decimals.positions[2].precision + values[1] * config.decimals.positions[1].precision;
    res = parseFloat(res.toFixed(2)); // result is rounded to two digits
  } else {
    // build numeric value from all pointers
    for (var k = 0; k < config.decimals.positions.length; k++) {
      if(values[k] > -1) {
        res += values[k] * config.decimals.positions[k].precision;
      }
    }
  }

  // make sure that value does not have integers, should not happen but it has been seen few times
  res = res % 1;


  var obj = getDecimalAmount(result, config);
  res = parseFloat(res.toFixed(obj.decimals));


  // rounding will be taken care in calculate-value.js
  return res;
}



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/decimalpointers/build-decimals.js
// module id = 833
// module chunks = 0